import Vue from 'vue'
import Confirm from './confirm.vue'

Vue.prototype.$my_confirm = function (options) {
  return new Promise((resolve, reject) => { // promise封装，ok执行resolve，no执行rejectlet
    if (options === undefined || options === null) {
      options = {
        content: ''
      }
    } else if (typeof options === 'string' || typeof options === 'number') {
      options = {
        content: options
      }
    }
    var Confirm1 = Vue.extend(Confirm)
    var component = new Confirm1({
      data: options
    }).$mount()
    document.body.appendChild(component.$el)
    component.operation1 = function () {
      resolve('保存并关闭')
    }
    component.operation2 = function () {
      resolve('直接关闭')
    }
    component.operation3 = function () {
      resolve('取消关闭')
    }
    Vue.nextTick(() => {
      component.visible = true
    })
  })
}
Confirm.install = function (Vue) {
  Vue.component(Confirm.name, Confirm)
}
export default Confirm


// WEBPACK FOOTER //
// ./src/common/Confirm/index.js